import { jsx as _jsx } from "react/jsx-runtime";
import AccordionControlled from "./AccordionControlled.js";
import AccordionUncontrolled from "./AccordionUncontrolled.js";
import AccordionTrigger from "./AccordionTrigger.js";
import AccordionContent from "./AccordionContent.js";
const Accordion = (props) => {
    const { active } = props;
    if (active !== undefined)
        return _jsx(AccordionControlled, { ...props });
    return _jsx(AccordionUncontrolled, { ...props });
};
Accordion.Trigger = AccordionTrigger;
Accordion.Content = AccordionContent;
Accordion.displayName = "Accordion";
export default Accordion;
